<template>
  <CModal class="modal-chooseFile"
          title="Danh sách tập tin âm thanh từ kho biên tập"
          :show.sync="isShowModal" :closeOnBackdrop="false"
          :size="'xl'">
    <div id="fileManagementAddSchedule" class="custom-scroll">
      <CCard class="content-fade-in mt-3p5">
        <CCardBody>
          <CRow class="mb-3 search-panel">
            <CCol xs="12" sm="6" md="4" lg="4" xl="3">
              <div class="form-group">
                <label for="datepicker">Từ ngày - đến ngày</label>
                <DatePicker id="datepicker" v-model="dateRange"
                            :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }"
                            locale="vi"
                            is-range class="datepicker"
                            :popover="{ visibility: 'click' }">
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      :value="inputValue.start + ' - ' + inputValue.end"
                      v-on="inputEvents.start"
                      class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                      readonly
                    />
                  </template>
                </DatePicker>
              </div>
            </CCol>
            <!-- <CCol xs="12" sm="4" md="4" lg="4" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')">
              <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data"
                          ref="districtCodeInput"></BaseSelect>
            </CCol>
            <CCol xs="12" sm="4" md="4" lg="4" xl="2" v-if="!$hasAuthor('ROLE_WARD')">
              <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
            </CCol> -->
            <CCol xs="12" sm="4" md="4" lg="4" xl="2">
              <BaseSelect :options="typeFileSelect.options" :data="typeFileSelect.data"
                          ref="typeFileSelect"></BaseSelect>
            </CCol>
            <!--          <CCol xs="12" sm="6" md="4" lg="4" xl="2">-->
            <!--            <BaseInput-->
            <!--              :options="titleInput.options"-->
            <!--              :data="titleInput.data"-->
            <!--              :listener="titleInput.listener"-->
            <!--            />-->
            <!--          </CCol>-->
            <CCol>
              <div class="form-group">
                <label style="color: white"></label>
                <div>
                  <CButton
                    style="float: right; margin-left: 5px"
                    color="primary"
                    v-c-tooltip.hover="'Tải lại'"
                    class="btn-action-primary"
                    @click="loadDataFile()">
                    <i class="fa fa-refresh"></i>&nbsp; Tải lại
                  </CButton>
                </div>
              </div>
            </CCol>
          </CRow>

          <CDataTable
            class="custom-scroll"
            :items="mainTable.items"
            :fields="mainTable.options.fields"
            :sorter="true"
            :loading="loading.value"
            :sorterValue="{ column: null, asc: 'true' }"
            :tableFilter="{ label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false}"
            :itemsPerPageSelect="{label: ' ', values: [10, 15, 20, 50], external: true}"
            :clickableRows="true"
            :hover="true"
            @pagination-change="changeItemPerPage"
            @row-clicked="rowClickTable">
            <template #index="{ index, item }">
              <td class="action-btn-group">
                <CInputRadio
                  type="radio"
                  addInputClasses="override-custom"
                  custom
                  :value="item.id"
                  name="fileAddScheduleSelected"
                  :checked="item.isSelected"
                />
              </td>
            </template>
            <template #createDate="{ item }">
              <td v-if="item.createDate != null">
                {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
              </td>
              <td v-else></td>
            </template>
            <template #description="{ item }">
              <td>
                <span v-if="item.description" :key="item.description" class="description"
                      v-c-tooltip.hover="item.description">
                  {{ item.description }}
                </span>
              </td>
            </template>
            <template #type="{ item }">
              <td>
                <span class="badge badge-light" v-if="item.type == 0">Biên tập</span>
                <span class="badge badge-light" v-else-if="item.type == 1">Chuyển đổi văn bản</span>
                <span class="badge badge-light" v-else-if="item.type == 2">Ghi âm tệp tin</span>
                <span class="badge badge-light" v-else-if="item.type == 3">Ghép tệp tin</span>
              </td>
            </template>
            <template #title="{ item }">
              <td>{{ item.title }}</td>
            </template>
            <template #action="{ item }">
              <td class="action-btn-group">
                <CInputRadio
                  type="radio"
                  addInputClasses="override-custom"
                  custom
                  :value="item.id"
                  name="test"
                  :checked="item.checked"
                />
              </td>
            </template>
            <template slot="no-items-view">
              <span style="color: #969696">Danh sách trống!</span>
            </template>
            <template slot="loading">
              <BaseFormLoading :loading="true"></BaseFormLoading>
            </template>
          </CDataTable>

          <div v-if="pagination && pagination.totalElement !== 0">
            <div style="display:flex; flex-wrap:wrap;">
              <div style="font-size:.95em;color:gray; padding-left:.75rem;">
                {{ fromElement }}-{{ toElement }} /
                {{ pagination.totalElement }} bản ghi
              </div>
              <nav style="margin-left:auto;">
                <CPagination
                  @update:activePage="updateActivePage"
                  :activePage.sync="pagination.activePage"
                  :pages="pagination.pages"
                  :total-rows="pagination.totalRows"
                  :per-page="pagination.pageSize"
                  prev-text="Prev"
                  next-text="Next"
                  hide-goto-end-buttons/>
              </nav>
            </div>
          </div>
        </CCardBody>
      </CCard>

      <BaseModal :title="'Xem tệp tin: ' + previewModel.title" :show.sync="previewModel.isShowModal"
                 :closeOnBackdrop="false">
        <template v-slot:body-wrapper>
          <div class="modal-body content-fade-in">
            <audio :src="previewModel.url" controls autoplay style="width: 100%" ref="previewAudio"></audio>
          </div>
        </template>
        <template v-slot:footer>
          <div slot="footer">
            <button type="button" class="btn btn-secondary" @click="closePreviewAudio()"><i
              class="fa fa-close"></i> Đóng
            </button>&nbsp;
          </div>
        </template>
      </BaseModal>

    </div>
    <template v-slot:footer>
      <button type="button" class="btn btn-primary" :disabled="itemChooseFileSelected == ''"
              @click="submitSelectedChooseFile()">
        <i class="fa fa-check"></i> Chọn
      </button>
      <button type="button" class="btn btn-secondary" @click="isShowModal = false"><i
        class="fa fa-times"></i> Hủy bỏ
      </button>
    </template>
  </CModal>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import BaseModal from "@/views/base/BaseModal";
import {DatePicker} from "v-calendar";
import VideoPlayer from "@/views/base/VideoPlayer";
import Multiselect from "vue-multiselect";

export default {
  name: "FileManagementAddSchedule",
  components: {
    BaseFormLoading,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    DatePicker,
    BaseModal,
    VideoPlayer,
    Multiselect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    return {
      isSelectedAllDevices: false,
      isShowModal: true,
      loading: {
        value: false,
      },
      previewModel: {
        isShowModal: false,
        title: '',
        url: ''
      },
      actionData: {
        model: {
          selectedAll: false,
          fileId: null,
          fileName: null
        }
      },
      dateRange: {
        start: that.$helper.subtractNowDate(30),
        end: new Date()
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {}
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: this.$hasAuthor('ROLE_DISTRICT') ? false : true,
          disabled: this.$hasAuthor('ROLE_DISTRICT') ? false : true
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      typeFileSelect: {
        options: {
          filter: true,
          label: "Loại tệp tin",
          selectAllText: "Tất cả loại tệp tin",
          'keyField': 'key',
          'valueField': 'value',
        },
        data: {
          name: "type",
          model: '',
          items: [
            {key: '0', value: 'Biên tập'},
            {key: '1', value: 'Chuyển đổi văn bản'},
            {key: '2', value: 'Ghi âm tệp tin'},
            {key: '3', value: 'Ghép tệp tin'},
          ],

        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
      titleInput: {
        options: {
          placeholder: "Tiêu đề bản tin",
          label: "Tiêu đề bản tin",
        },
        data: {
          name: "name",
          model: "",
        },
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "#", sorter: false, filter: false},
            {key: "createDate", label: "Ngày tạo", _style: "max-width:5%; width:5%"},
            {key: "title", label: "Tiêu đề"},
            {key: "duration", label: "Thời lượng"},
            {key: "description", label: "Mô tả", sorter: false, filter: false},
            {key: "locationName", label: "Địa bàn"},
            {key: "fileTypeName", label: "Lĩnh vực"},
            // {key: "url", label: "Nội dung bản tin", sorter: false, filter: false},
            {key: "type", label: "Loại tệp tin", sorter: true, filter: false},
            // {key: "action", label: "Thao tác", sorter: false, filter: false},
          ],
          slots: [
            "index", "createDate", "action", "url", "type", "description"
          ],
          sorter: true,
          columnFilter: false,
        },
        items: [],
      },
      pagination: {
        activePage: 1,
        pages: 1,
        pageSize: 10,
        totalElement: 0,
        totalRows: 0
      },
      itemChooseFileSelected: ''
    };
  },
  methods: {
    loadDataFile(isRefresh) {
      let that = this;
      that.loading.value = true;
      that.$helper.loadDataSource({
        url: "/file-management/getPages",
        dataSubmit: function () {
          var params = that.$helper.setupDataSubmit(that.$data);
          params.fromDate = that.$helper.formatDateDDMMYYYY(that.dateRange.start);
          params.toDate = that.$helper.formatDateDDMMYYYY(that.dateRange.end);
          params.pageSize = that.pagination.pageSize;
          params.pageNumber = that.pagination.activePage - 1;
          params.status = 2;
          return params;
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            if (!isRefresh) {
              that.mainTable.items = [];
            }
            let _data = response.data.data;
            _data.dataContent.content.map((each) => {
              if (that.itemChooseFileSelected != null && that.itemChooseFileSelected != ''
                && that.itemChooseFileSelected.id && each.id == that.itemChooseFileSelected.id) {
                each.isSelected = true;
              } else {
                each.isSelected = false;
              }
              that.mainTable.items.push(each);
            });
            that.setupPagination(_data);
            that.isShow = true;
          }
          that.loading.value = false;
        },
        errorCallback: function (error) {
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    updateActivePage: function (activePage) {
      this.pagination.activePage = activePage;
      this.loadDataFile();
    },
    setupPagination(_dataResponse) {
      this.pagination.pages = Math.ceil(_dataResponse.totalElement / this.pagination.pageSize);
      this.pagination.totalElement = _dataResponse.totalElement;
    },
    rowClickTable(...args) {
      this.mainTable.items.map((item, index) => {
        if (index === args[1]) {
          item.isSelected = true;
          this.itemChooseFileSelected = item;
        } else {
          item.isSelected = false;
        }
      });
    },
    submitSelectedChooseFile() {
      if (this.itemChooseFileSelected == null || this.itemChooseFileSelected == '') {
        return;
      }
      this.$emit('file:selected', this.itemChooseFileSelected);
    },
    changeItemPerPage(value) {
      this.pagination.activePage = 1;
      this.pagination.pageSize = value;
      this.loadDataFile();
    },
    viewFile(title, url) {
      this.previewModel.url = url;
      this.previewModel.isShowModal = true;
      this.previewModel.title = title;
    },
    closePreviewAudio() {
      this.$refs.previewAudio.pause();
      this.previewModel.isShowModal = false;
    },
  },
  created: function () {
  },
  mounted() {
    // if (!this.$hasAuthor("ROLE_ADMIN")) {
      this.loadDataFile();
    // }
  },
  watch: {
    isShowModal: function (value) {
      if (!value) {
        this.$emit("close-modal", false);
      }
    },
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataFile();
      } else {
        this.dateRange = {
          start: this.$helper.subtractNowDate(30),
          end: new Date()
        }
      }
    },
    'districtCodeInput.data.model': function (value) {
      if (value) {
        this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        this.wardCodeInput.options.disabled = false;
      } else {
        this.wardCodeInput.data.items = [];
        this.wardCodeInput.options.disabled = true;
      }
      this.wardCodeInput.data.model = null
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
      this.loadDataFile();
    },
    'typeFileSelect.data.model': function () {
      this.loadDataFile();
    }
  },
  computed: {
    fromElement: function () {
      return (this.pagination.activePage - 1) * this.pagination.pageSize + 1;
    },
    toElement: function () {
      return (
        (this.pagination.activePage - 1) * this.pagination.pageSize +
        this.mainTable.items.length
      );
    },
  },
};
</script>

<style>
.row-2 .form-group {
  margin-top: 0 !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect.input-error .multiselect__tags {
  border-color: #ff7070;
}
</style>
<style lang="scss">

#fileManagementAddSchedule {
  .form-check-input {
    width: 16px;
    height: 16px;
  }

  .multiselect {
    min-height: 36px !important;
    margin-top: -2px;

    &.input-error .multiselect__tags {
      border-color: #ff7070;
    }

    .valid-error {
      animation: fade-down ease-out .2s;
      animation-fill-mode: forwards;
    }

    .multiselect__tags {
      padding-top: 0px !important;
      min-height: 36px !important;
    }


    .multiselect__tag {
      margin-top: 5px !important;
      margin-bottom: 0 !important;
    }
  }

  .multiselect__input {
    line-height: unset !important;
    font-size: 14px !important;
    padding-top: 5px !important;
  }


  .multiselect__placeholder {
    padding-top: 7px !important;
    margin: 0 !important;
  }
}
</style>
